import React, { ComponentProps, ReactElement, ReactNode } from 'react';

import PropTypes from 'prop-types';

import ActivityCard from '../ActivityCard';
import ListRow, { ListRowProps } from '../layout/ListRow';

type Item = {
  value: ReactNode;
  label: ReactNode;
};

type AggregatedActivityCardProps = ComponentProps<typeof ActivityCard> & {
  items?: Item[];
  renderRow?: (props: ListRowProps & { key?: string | number }) => ReactElement;
};

/**
 * AggregatedActivityCard component. Describes a single activity with multiple changes inside.
 */
const AggregatedActivityCard = React.forwardRef<
  HTMLDivElement,
  AggregatedActivityCardProps
>(({ items = [], renderRow = (p) => <ListRow {...p} />, ...props }, ref) => {
  if (!items.length) {
    return null;
  }
  return (
    <ActivityCard ref={ref} {...props}>
      <div
        css={[
          {
            display: 'flex',
            flexDirection: 'column',
            minHeight: 28,
          },
        ]}
      >
        {renderRow &&
          items.map((item, index) => renderRow({ key: index, ...item }))}
      </div>
    </ActivityCard>
  );
});

AggregatedActivityCard.displayName = 'AggregatedActivityCard';

AggregatedActivityCard.propTypes = {
  ...ActivityCard.propTypes,
  /** Render custom row content. Props: ({ items }) */
  renderRow: PropTypes.func,
  /** Array of items to render inside this card list */
  items: PropTypes.arrayOf(PropTypes.any.isRequired),
};

export default Object.assign(AggregatedActivityCard, {
  ListRow,
});
